export default __webpack_public_path__ + "c8b28bb001165f8156511469536564b7.png";